import a from "./crewHqBracketA";
import b from "./crewHqBracketB";
import c from "./crewHqBracketC";

const crewHqBracketImage = `data:image/jpeg;base64,${a}${b}${c}`;

export default crewHqBracketImage;
